import { createTypes, createAction } from "lib/action";

const LOAD_WORKING_HOUR = createTypes("working_hour", "load");
const SHOW_WORKING_HOUR = createTypes("working_hour", "show");
const CREATE_WORKING_HOUR = createTypes("working_hour", "create");
const UPDATE_WORKING_HOUR = createTypes("working_hour", "update");
const DELETE_WORKING_HOUR = createTypes("working_hour", "delete");

const loadWorkingHours = {
  request: (params, token) => createAction(LOAD_WORKING_HOUR.REQUEST, { params, token }),
  success: data => createAction(LOAD_WORKING_HOUR.SUCCESS, { data }),
  failure: err => createAction(LOAD_WORKING_HOUR.FAILURE, { err }),
};

const showWorkingHour = {
  request: (id, user_id, token) => createAction(SHOW_WORKING_HOUR.REQUEST, { id, user_id, token }),
  success: data => createAction(SHOW_WORKING_HOUR.SUCCESS, { data }),
  failure: err => createAction(SHOW_WORKING_HOUR.FAILURE, { err }),
};

const createWorkingHour = {
  request: (params, token) => createAction(CREATE_WORKING_HOUR.REQUEST, { params, token }),
  success: data => createAction(CREATE_WORKING_HOUR.SUCCESS, { data }),
  failure: err => createAction(CREATE_WORKING_HOUR.FAILURE, { err }),
};

const updateWorkingHour = {
  request: (params, id, token) => createAction(UPDATE_WORKING_HOUR.REQUEST, { params, id, token }),
  success: data => createAction(UPDATE_WORKING_HOUR.SUCCESS, { data }),
  failure: err => createAction(UPDATE_WORKING_HOUR.FAILURE, { err }),
};

const deleteWorkingHour = {
  request: (id, token) => createAction(DELETE_WORKING_HOUR.REQUEST, { id, token }),
  success: id => createAction(DELETE_WORKING_HOUR.SUCCESS,  { id } ),
  failure: err => createAction(DELETE_WORKING_HOUR.FAILURE, { err }),
};


export {
  loadWorkingHours,
  showWorkingHour,
  createWorkingHour,
  updateWorkingHour,
  deleteWorkingHour,
  LOAD_WORKING_HOUR,
  SHOW_WORKING_HOUR,
  CREATE_WORKING_HOUR,
  UPDATE_WORKING_HOUR,
  DELETE_WORKING_HOUR,
};
